import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_SETTINGS_FEATURE_KEY, UserSettingsState } from './user-settings.reducer';

export const selectUserSettingsState = createFeatureSelector<UserSettingsState>(USER_SETTINGS_FEATURE_KEY);

export const selectUserSettings = createSelector(
  selectUserSettingsState,
  (state: UserSettingsState) => state.userSettings
);

export const selectUserSettingsLoaded = createSelector(
  selectUserSettingsState,
  (state: UserSettingsState) => state.loaded
);

export const selectUserSettingsError = createSelector(
  selectUserSettingsState,
  (state: UserSettingsState) => state.error
);
